import { Box, Container, Typography } from '@mui/material';

const TermsOfService: React.FC = () => {
  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Typography variant="h2" gutterBottom sx={{ display: 'flex' }}>
          Terms and Conditions
        </Typography>
        <Typography variant="h4" gutterBottom>
          Introduction
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          These Terms and Conditions ("Terms") govern your use of the Airship
          product, a B2B SaaS application, provided by Fieldwork Systems, Inc.
          d/b/a Airship ("Airship"). By accessing or using the Airship product,
          you agree to be bound by these Terms and acknowledge that they
          constitute a legal agreement between you and Airship. If you do not
          agree to these Terms, do not use the Airship product.
        </Typography>

        <Typography variant="h4" gutterBottom>
          Terms and Conditions for Airship Product
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          By accessing or using the Airship product ("Application"), you agree
          to be bound by these Terms and Conditions ("Terms"). If you do not
          agree to these Terms, do not use the Application. Fieldwork Systems,
          Inc. d/b/a Airship ("Airship") reserves the right to update these
          Terms at any time without prior notice.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. License Grant
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          Airship grants you a non-exclusive, non-transferable, revocable
          license to access and use the Application solely for your internal
          business purposes.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Restrictions
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          You shall not (i) modify, copy, distribute, transmit, display,
          perform, reproduce, publish, license, create derivative works from,
          transfer, or sell any information, software, products, or services
          obtained from the Application; (ii) use the Application for any
          unlawful purpose; (iii) interfere with or disrupt the integrity or
          performance of the Application or the data contained therein; or (iv)
          attempt to gain unauthorized access to the Application or its related
          systems or networks.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Intellectual Property
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          The Application and all intellectual property rights therein are and
          shall remain the property of Airship. You shall not remove, obscure,
          or alter any proprietary rights notices.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Derivative Data
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          Airship shall have the right to create derivative data based on your
          use of the Application. However, Airship shall gain no rights to any
          Personally Identifiable Information (PII) or other data that is
          proprietary to you. Airship shall maintain the confidentiality of your
          PII and proprietary data in accordance with the Confidentiality and
          Data Privacy clauses of these Terms.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Confidentiality
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: '16px' }}>
          You acknowledge that the Application contains proprietary and
          confidential information. You shall maintain the confidentiality of
          such information and shall not disclose it to any third party.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
